import React, { useState, useEffect } from 'react';
import { Dialog } from '@reach/dialog';

type SliderModalProps = {
  showModal: boolean;
  handleCancel: () => void;
  body: any;
  title: string;
  className?: string;
}

const SliderModal: React.FC<SliderModalProps> = (props) => {
  const {
    showModal,
    handleCancel,
    body,
    title,
    className="",
  } = props;

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (showModal) {
      setIsOpen(true);
    } else {
      document.querySelector('.c-modal-slider')?.classList.add('closed');
      setTimeout(() => {
        setIsOpen(false);
      }, 350);
    }
  }, [showModal]);

  return (
      <Dialog
        isOpen={isOpen}
        className={`c-modal-slider ${className}`}
        id={title}
        aria-label={title}
        onDismiss={handleCancel}
      >
        <button
          className="c-btn-icon c-modal-slider__close"
          onClick={handleCancel}
        >
          <div className="c-btn__inner">
            <i className="c-btn__icon fal fa-times" />
          </div>
        </button>
        <div className="h1 c-modal__heading">{title}</div>
        <div
          className={`u-margin-center u-margin-top u-padding-bottom-80
            ${!className.includes("c-modal-slider-90") ? ' l-container-med' : ''}`}
        >
          {body}
        </div>
      </Dialog>
  );
};

export default SliderModal;